import FirstSlider from './firstSlider/firstslider'
import SecondSection from './secondslider/secondSlider';
import ThirdSlider from  './thirdSlider/thirdSlider'
// import slider1 from './assets/slider-1old.jpg'
import coverimage1 from '../../assets/coveriamge.jpg'
import slider2 from '../../assets/softwaredevelopment.PNG'
import slider3 from '../../assets/innovationkeys.jpg'

const images = [
  {
    imgURL:
      "https://images.pexels.com/photos/461198/pexels-photo-461198.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    imgAlt: "img-1",
    key:1,
    ui:()=><FirstSlider img={coverimage1}/>
  },
  {
    imgURL:
      "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    imgAlt: "img-2",
    key:2,
    ui:()=><SecondSection img={slider2}/>
  },
  {
    imgURL:
      "https://images.pexels.com/photos/1128678/pexels-photo-1128678.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    imgAlt: "img-3",
    key:3,
    ui:()=><ThirdSlider img={slider3}/>
  },
];






export default images;
